import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useGrossProductCollection } from "./useGrossProductCollection";
import i18n from "i18next";
import _ from "lodash";
import { EntGrossProductCollection } from "../../../../models/organic/grossProductCollection";
import { EntGrossProductCollectionFilter } from "../../../../models/filters/organic/grossProductCollectionFilter";
import { useLazyGetGrossProductCollectionListAllQuery } from "../../../../redux/api/organic/grossProductCollectionApi";
import { EmptyData } from "../../../../components/empty/emptyData";
import { PageHeader } from "../../../../components/page-header";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { FilterGrossProductCollection } from "./FilterGrossProductCollection";
import { AddGrossProductCollectionModal } from "./AddGrossProductCollection";


enum FormField {
  year,
  regionId,
  productTypeIds,
  farmCategoryIds,
  unitMeasurementIds
}

export const GrossProductCollection = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntGrossProductCollection>(new EntGrossProductCollection());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()

  const [getArchiveFolders] = useLazyGetGrossProductCollectionListAllQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntGrossProductCollection, EntGrossProductCollectionFilter>({
	initialFilter: new EntGrossProductCollectionFilter(),
	query: getArchiveFolders
  });

  const {
	onAddGrossProductCollection,
	onDeleteGrossProductCollection,
	onEditGrossProductCollection
  } = useGrossProductCollection(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isReportAvailable = storedData.some((route: any) => (route.alias === "/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntGrossProductCollection) => {
	setSelectedItem(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntGrossProductCollectionFilter => {
	let filt: EntGrossProductCollectionFilter = _.clone(filter);
	filt.year = form.getFieldValue(FormField.year) ?? null;
	filt.regionId = form.getFieldValue(FormField.regionId) ?? null;
	filt.productTypeIds = form.getFieldValue(FormField.productTypeIds) ?? null;
	filt.farmCategoryIds = form.getFieldValue(FormField.farmCategoryIds) ?? null;
	filt.unitMeasurementIds = form.getFieldValue(FormField.unitMeasurementIds) ?? null;
	filt.page = 1;
	return filt;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.year, value: null },
	  { name: FormField.regionId, value: null },
	  { name: FormField.productTypeIds, value: null },
	  { name: FormField.farmCategoryIds, value: null },
	  { name: FormField.unitMeasurementIds, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th style={ { width: "90px" } }>{ t('Год') } </th>
		  <th>{ t('Регион') }</th>
		  <th>{ t('Категория фермы') }</th>
		  <th>{ t('Тип продукта') }</th>
		  <th>{ t('Единица измерения') }</th>
		  <th>{ t('Количество') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<th colSpan={ 7 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		) : null }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item.year }</td>
			<td>{ i18n.language === 'ru' ? item.region?.nameRu : item.region?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.farmCategory?.nameRu : item.farmCategory?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.productType?.nameRu : item.productType?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.unitMeasurement?.nameRu : item.unitMeasurement?.nameKy }</td>
			<td>{ item.amount }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteGrossProductCollection(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) : (
		  <tr>
			<td colSpan={ 9 }>
			  <EmptyData/>
			</td>
		  </tr>
		) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('Валовый сбор продукции') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntGrossProductCollection())
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterGrossProductCollection
		  onSearch={ searchHandleClick }
		  onReset={ () => {
			clearFields();
			searchHandleClick()
		  } }
		  formField={ FormField }
		  form={ form }
		/> }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddGrossProductCollectionModal
		item={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== null ? onEditGrossProductCollection : onAddGrossProductCollection }
	  />
	  { contextHolder }
	</>
  );
}
